/** PNG/JPEG data URL or hosted image URL — used for signature fields in certificate wizards */
export function isFilledSignatureValue(v: unknown): boolean {
  const s = String(v ?? '').trim();
  return s.startsWith('data:image') || /^https?:\/\//i.test(s);
}
